export const languageDetector = (): any => {
	let localStorageLng = localStorage.getItem('_facturando_lng');
	if (localStorageLng) return localStorageLng.includes('en') ? 'en' : 'es';

	// fallback language (spanish)
	return 'es';
};
